import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogDescription,
	DialogClose,
} from '@/components/ui/dialog'
import { useEffect, useState } from 'react'
import { qrService } from '@/lib/qr'
import { useToast } from '@/hooks/use-toast'
import { createEthereumURI } from '@/utils'
import { Card } from '@/components/ui/card'
import { X, Loader2 } from 'lucide-react'

interface WalletQRModalProps {
	open: boolean
	onOpenChange: (open: boolean) => void
	walletAddress: string
}

const WalletQRModal = ({
	open,
	onOpenChange,
	walletAddress,
}: WalletQRModalProps) => {
	const [walletAddressQR, setWalletAddressQR] = useState<string | null>(null)
	const { toast } = useToast()

	const generateWalletQR = async () => {
		try {
			const qrPayload = createEthereumURI(walletAddress)
			const qr = await qrService.generateQR(qrPayload)
			setWalletAddressQR(qr)
		} catch (error) {
			console.error('Error generating QR:', error)
			toast({
				title: 'QR Code Generation Failed',
				description: 'Unable to generate wallet QR.',
				variant: 'destructive',
			})
		}
	}

	useEffect(() => {
		if (open && walletAddress) {
			generateWalletQR()
		}
	}, [open, walletAddress])

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="sm:max-w-md bg-transparent border-0">


				<div className="flex flex-col items-center space-y-4">

					{walletAddressQR ? (
						<Card className="p-4 bg-white border-0 rounded-[16px] w-full">
							<DialogClose asChild>
								<button
									className="absolute top-8 right-8 w-8 h-8 flex items-center justify-center rounded-full text-[#ffffff] bg-white/10 hover:bg-white/20 transition"
									aria-label="Close">
									<X className="w-5 h-5 text-[#000000]" />
								</button>
							</DialogClose>
							<DialogHeader>
								<DialogTitle className="text-[16px] leading-[18px] text-[#18181B] mb-2 font-semibold font-figtree mt-11">
									Wallet Address QR
								</DialogTitle>
								<DialogDescription className="text-xs leading-4 font-medium font-figtree mt-0 text-[#676767]">
									Scan this QR code to get the wallet address.
								</DialogDescription>
							</DialogHeader>
							<img
								src={walletAddressQR}
								alt="Wallet QR Code"
								className="w-full h-[280px] mt-4"
							/>
							<div className="w-full text-start pb-3 px-6 rounded-lg">
								<label htmlFor="" className='text-[#181818] text-[13px] leading-[14px] font-medium font-figtree'>Address:</label>
								<code className="text-xs text-start leading-4 font-medium text-[#676767] break-all block">
									{walletAddress}
								</code>
							</div>
						</Card>
					) : (
						<div className="w-48 h-48 flex items-center justify-center">
							<Loader2 className="h-8 w-8 animate-spin text-[#BABABB]" />
						</div>
					)}


				</div>
			</DialogContent>
		</Dialog>
	)
}

export default WalletQRModal
